import React from 'react'
import { useParams } from 'react-router-dom'
import useAuthGuard from '../../app/guards/useAuthGuard'
import { ConfirmProvider } from '../../shared/components/confirm/ConfirmProvider'
import NewsFeed from '../../features/news/components/NewsFeed'

function toPostId(raw: string | undefined): number | null {
  if (raw === undefined || !/^\d+$/.test(raw)) {
    return null
  }

  const parsed = Number(raw)
  return Number.isSafeInteger(parsed) && parsed > 0 ? parsed : null
}

function NewsPage() {
  useAuthGuard()
  // Null covers both "no deep link" and "a param that is not a post id" — the latter must not reach
  // the server, so it is turned away here rather than producing a request that can only 404.
  const { postId } = useParams<{ postId: string }>()

  return (
    <ConfirmProvider>
      <NewsFeed hasDeepLink={postId !== undefined} deepLinkedPostId={toPostId(postId)} />
    </ConfirmProvider>
  )
}

export default NewsPage
